import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/components/AuthCallback";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: "120px 32px", maxWidth: 640, margin: "0 auto" }}>
                    <h1 style={{ fontFamily: "Fraunces, serif", color: "#1C2B45" }}>
                        Something went wrong.
                    </h1>
                    <p style={{ color: "#48566E", marginTop: 12 }}>
                        {String(this.state.error.message || this.state.error)}
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollReset() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function AppRoutes() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Detect the OAuth session_id in the URL fragment synchronously during render
    // and process it before any /auth/me check can run.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Landing />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        if (
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
            return;
        }
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        setLenis(lenis);
        let raf = requestAnimationFrame(function loop(t) {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        });
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollReset />
                <AppRoutes />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            borderRadius: "2px",
                            background: "#1C2B45",
                            color: "#F7F6F1",
                            border: "1px solid rgba(28,43,69,0.25)",
                            fontFamily: "Inter, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
